import { render } from "./TradeOrderContainer_cf.vue?vue&type=template&id=f24f070a"
import script from "./TradeOrderContainer_cf.vue?vue&type=script&lang=js"
export * from "./TradeOrderContainer_cf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__